// javascripts/app.js
// javascripts/app.js

//True if the userAgent is mobile

var isMobile = false;
if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
    isMobile = true;
}


function encode_utf8(s) {
    var encoded_s = s;
    try {
        encoded_s = encodeURIComponent(s);
    } catch (e) {
        try {
            encoded_s = escape(s);
        } catch (error) {
            try {
                encoded_s = unescape(encodeURIComponent(s));
            } catch (error) {
                encoded_s = s;
            }
        }

    }
    return encoded_s;

}

function decode_utf8(s) {
    var decoded_s = s;
    try {
        decoded_s = decodeURIComponent(s);
    } catch (e) {
        try {
            decoded_s = unescape(s);
        } catch (e) {
            try {
                decoded_s = decodeURIComponent(escape(s));
            } catch (e) {
                decoded_s = s;
            }
        }
    }
    return decoded_s;
}

function decode_utf8_link(s) {
    var decoded_s = s;
    try {
        decoded_s = decodeURIComponent(s);
    } catch (e) {
        try {
            decoded_s = unescape(s);
        } catch (e) {
            try {
                decoded_s = decodeURIComponent(escape(s));
            } catch (e) {
                decoded_s = s;
            }
        }
    }
    //quotes still need to be escaped
    decoded_s = decoded_s.replace(/\"/gi, '%22');
    return decoded_s;
}


function cookieAsyncCall() {

    $.ajax({
        url: '/initializeCookie',
        type: 'POST',
        data: {
            distinct_user_hash: gon.distinct_user_hash
        },
        dataType: 'json'
    });
}

//this function initialize the cookies when the app start

function initializeCookie() {
    if (_.isFalsy(gon.distinct_user_hash) && typeof analytics !== 'undefined' && analytics.getAnonymousId) {
        gon.distinct_user_hash = analytics.getAnonymousId();
    }
    cookieAsyncCall();
}

function bindFeedback() {
    $('#feedback_link').click(function() {
        $('#feedback_overlay').fadeIn('fast');
        $('#feedback_holder').show().animate({
            'opacity': '1',
            'margin-top': '0px'
        });
        $('#drop').hide();
    });
    $('#feedback_overlay').click(function() {
        $(this).fadeOut('fast');
        $('#feedback_holder').hide().animate({
            'opacity': '0',
            'margin-top': '60px'
        });
        $('#drop').show();
    });
    $('#close_feedback').click(function() {
        $('#feedback_overlay').fadeOut('fast');
        $(this).parent().parent().hide().animate({
            'opacity': '0',
            'margin-top': '60px'
        });
        $('#drop').show();
    });


    $('#internal_feedback_form').submit(function(e) {
        e.preventDefault();
        $.ajax({
            url: '/feedback',
            data: $(this).serialize(),
            dataType: 'json',
            type: 'post',
            success: function(response) {
                $('.feedhide').hide();
                $('#feedback_thanks').show();
            }
        });

    });
}

function getParentUrlLink() {
    if (parent_url || typeof url.split('#')[1] != 'undefined') {
        return parent_url;
    }
    var parentReferrer = (window.location != window.parent.location) ? document.referrer : document.location.href;
    if (parentReferrer && typeof parentReferrer != 'undefined') {
        parent_url = parentReferrer;
    } else {
        parent_url = backURL;
    }
    return parent_url.split(/[?#]/)[0];
}

function resetForm($form) {
    $form.find('input:text, input:password, input:file, select, textarea').val('');
    $form.find('input:radio, input:checkbox')
        .removeAttr('checked').removeAttr('selected');
}
// String functions
String.prototype.trunc = function(n) {
    return this.substr(0, n - 1) + (this.length > n ? '...' : '');
};

String.prototype.startsWith = function(str) {
    return this.slice(0, str.length) == str;
};

$(function() {
    bindFeedback();
});
